import { storage } from 'BASE/common/util/util.storage';
import vue_seamless_scroll from 'vue-seamless-scroll';

export default {
    data: function () {
        return {
            IsOrderByDesc: true,
            Element: "#marquee",
            List: [],
            EffectiveTime: 5,  //單位分鐘
        };
    },
    components: {
        vue_seamless_scroll
    },
    computed: {
        seamlessScrollOption() {
            let _listLength = this.List.length;
            return {
                step: 1,                        //数值越大速度滚动越快
                limitMoveNum: _listLength,      //开始无缝滚动的数据量
                hoverStop: true,                //是否开启鼠标悬停stop
                direction: 2,                   // 0向下 1向上 2向左 3向右
                //openWatch: true,                //开启数据实时监控刷新dom
            }
        },
        isLogin(){
            return this.$store.state.userinfo.isLogin;
        }
    },
    methods: {
        async getMarquee() {
            let _this = this;
            _this.List = [{"ID":0, "MessageType":"", "Title":""}];  //一定要有初始預設，不能設[]否則跑馬燈套件第一次算長度會錯

            let _tag = _this.isLogin ? storage.keys.LOGIN_MARQUEE : storage.keys.UNLOGIN_MARQUEE;
            let _regMarquee = storage.local.get(_tag);
            if (_regMarquee) {
                _this.List = _regMarquee;
            }
            else {
                try {
                    let _result = await $.post(`/api/Annoucement/GetMarquee/${_this.IsOrderByDesc}`);
                    if (_result) {
                        let _newExpiresTime = new Date().getTime() + (_this.EffectiveTime * 60 * 1000);
                        storage.local.set(_tag, _result, _newExpiresTime);
                        _this.List = _result;
                    }
                }
                catch (err) {
                    console.error(err);
                }
            }

            
            setTimeout(function(){
                _this.List = storage.local.get(_tag);
            },200);
        }
    },
    async mounted() {
        await this.getMarquee();
    }
};